import React from 'react'
import './index.scss'

interface LabelCountProps {
    count: number
    onClick?: () => void
}

const LabelCount: React.FC<LabelCountProps> = ({ count, onClick }) => {
    return (
        <div
            className="countLabel"
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
        >
            {count}
        </div>
    )
}

export default LabelCount
